import { type ReactNode } from 'react';

import OptimizelyIconSVG from '@frontend/assets/o-logo.svg';

import {
  container,
  navOrg,
  navProduct,
  navSlash,
  slotWrapper,
  spacer,
} from './GlobalHeaderSkeleton.css';

type GlobalHeaderSkeletonProps = {
  children?: ReactNode;
};

export function GlobalHeaderSkeleton({ children }: GlobalHeaderSkeletonProps) {
  return (
    <div className={container} aria-hidden="true">
      <div style={{ width: 122, flexShrink: 0, display: 'flex', alignItems: 'center' }}>
        <img src={OptimizelyIconSVG} alt="" style={{ height: 30, width: 'auto' }} />
      </div>
      <div className={navOrg} />
      <span className={navSlash}>
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fal"
          data-icon="slash-forward"
          className="svg-inline--fa fa-slash-forward"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          width="16"
          height="16"
        >
          <path
            fill="currentColor"
            d="M312.2 2.281c-7.469-4.484-17.34-2.125-21.94 5.484l-288 480c-4.562 7.578-2.094 17.41 5.5 21.95C10.34 511.3 13.19 512 16 512c5.406 0 10.72-2.766 13.72-7.766l288-480C322.3 16.66 319.8 6.828 312.2 2.281z"
          />
        </svg>
      </span>
      <div className={navProduct} />
      <div className={spacer} />
      <div className={slotWrapper}>{children}</div>
    </div>
  );
}
